import { render, staticRenderFns } from "./CustomViews.vue?vue&type=template&id=09bfcc3e&scoped=true&"
import script from "./CustomViews.vue?vue&type=script&lang=js&"
export * from "./CustomViews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bfcc3e",
  null
  
)

export default component.exports